import { FaTrashAlt, FaCheck, FaTimes, FaPlus } from 'react-icons/fa'; // Import React Icons
import useNotesStore from '@/store/NotesStore';
import { useState } from 'react';
import { RiPencilFill } from 'react-icons/ri';

const Notes = () => {

  const [newNoteContent, setNewNoteContent] = useState<string>('');
  const [editingNoteId, setEditingNoteId] = useState<string | null>(null);
  const [editingContent, setEditingContent] = useState<string>('');

  const notes = useNotesStore(state => state.notes)
  const addNote = useNotesStore(state => state.addNote)
  const deleteNote = useNotesStore(state => state.deleteNote)
  const updateNote = useNotesStore(state => state.updateNote)

  const handleAddNote = () => {
    if (newNoteContent.trim()) {
      addNote(newNoteContent);
      setNewNoteContent('');
    }
  };

  const handleEditNote = (noteId: string, currentContent: string) => {
    setEditingNoteId(noteId);
    setEditingContent(currentContent);
  };

  const handleSaveEdit = () => {
    if (editingNoteId && editingContent.trim()) {
      updateNote(editingNoteId, editingContent);
      setEditingNoteId(null);
      setEditingContent('');
    }
  };

  const handleDeleteNote = (noteId: string) => {
    deleteNote(noteId);
  };

  return (
    <div className="bg-zinc-200 text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100 flex flex-col items-center p-4 w-full h-full lg:w-[1000px] lg:h-[600px] overflow-y-auto">
      <h1 className="text-3xl font-bold mt-28">Notes</h1>

      <form
        onSubmit={e => {
          e.preventDefault();
          handleAddNote()
        }}
        className="relative my-8 w-full max-w-md"
      >
        <input
          type="text"
          value={newNoteContent}
          onChange={(e) => setNewNoteContent(e.target.value)}
          className="w-full p-3 select-text bg-zinc-300 text-zinc-900 dark:bg-zinc-800 dark:text-zinc-100 rounded-md border border-zinc-200 dark:border-zinc-800 focus:outline-none"
          placeholder="Enter your note..."
        />
        <button
          type="submit"
          className={`absolute -top-1.5 right-1 ${newNoteContent ? "scale-100" : "scale-0"} transition-all duration-300 ease-in-out mt-3 p-3 bg-zinc-300/60 dark:bg-zinc-700/60 rounded-md text-black dark:text-white bg-zinc-300 dark:hover:bg-zinc-700 focus:outline-none`}
        >
          <FaPlus />
        </button>
      </form>

      <div className="w-full min-h-72">
        {notes.length === 0 ? (
          <div className='flex items-center justify-center h-64 mb-10'>
            <p className="text-center text-zinc-600 dark:text-zinc-400">No notes yet</p>
          </div>
        ) : (
          <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 sm:py-4 select-text">
            {notes.map((note) => (
              <li key={note.id} className="bg-zinc-300/60 dark:bg-zinc-800/60 group/note px-4 py-2 flex items-center justify-between rounded-lg shadow-lg">
                {editingNoteId === note.id ? (
                  <>
                    <input
                      type="text"
                      value={editingContent}
                      onChange={(e) => setEditingContent(e.target.value)}
                      className="w-full px-3 py-1 bg-zinc-300/60 dark:bg-zinc-700/60 text-black dark:text-white rounded-md mr-2 border border-zinc-700 focus:outline-none"
                    />
                    <div className="flex space-x-1">
                      <button
                        onClick={handleSaveEdit}
                        className="p-2 transition-colors duration-200 bg-zinc-200 dark:bg-zinc-700/60 rounded-md text-zinc-900 dark:text-zinc-100 hover:text-zinc-100 hover:bg-green-600 dark:hover:bg-green-600 focus:outline-none"
                      >
                        <FaCheck />
                      </button>
                      <button
                        onClick={() => setEditingNoteId(null)}
                        className="p-2 opacity-0 group-hover/note:opacity-100 transition-colors duration-200 bg-zinc-200 dark:bg-zinc-700/60 rounded-md text-zinc-900 dark:text-zinc-100 hover:text-zinc-100 hover:bg-red-600 dark:hover:bg-red-500 focus:outline-none"
                      >
                        <FaTimes />
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <p>{note.content}</p>
                    <div className="flex space-x-1">
                      <button
                        onClick={() => handleEditNote(note.id, note.content)}
                        className="p-2 opacity-0 group-hover/note:opacity-100 transition-colors duration-200 bg-zinc-200 dark:bg-zinc-700/60 rounded-md text-zinc-900 dark:text-zinc-100 hover:text-zinc-100 hover:bg-zinc-600 dark:hover:bg-zinc-600 focus:outline-none"
                      >
                        <RiPencilFill />
                      </button>
                      <button
                        onClick={() => handleDeleteNote(note.id)}
                        className="p-2 opacity-0 group-hover/note:opacity-100 transition-colors duration-200 bg-zinc-200 dark:bg-zinc-700/60 rounded-md text-zinc-900 dark:text-zinc-100 hover:text-zinc-100 hover:bg-red-600 dark:hover:bg-red-500 focus:outline-none"
                      >
                        <FaTrashAlt />
                      </button>
                    </div>
                  </>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Notes;
